import { LoanFileType } from './LoanFileType';

export const LoanFileTypeOptions = [
    {
        id: LoanFileType.L1,
        name: 'L-1',
    },
    {
        id: LoanFileType.Termsheet,
        name: 'Term Sheet',
    },
    {
        id: LoanFileType.PropertyManagementAgreement,
        name: 'Prop. Mngmnt Agrmnt',
    },
    {
        id: LoanFileType.Other,
        name: 'Other',
    },
];
